import { memo } from "react";
import styles from "./AgentMailbox.module.scss";

// фирменные цвета planr: синий, фиолетовый, зелёный, оранжевый, тёмно-синий
const COLORS = ["#36acd7", "#7d36d7", "#1dd278", "#ea561e", "#00273d", "#369cd7"];

const colorOf = (seed: string) => {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash = (hash * 31 + seed.charCodeAt(i)) | 0;
    }
    return COLORS[Math.abs(hash) % COLORS.length];
};

/** Две буквы: из названия без кавычек и «ООО/ИП/АО» */
export const initialsOf = (name: string) => {
    const words = (name || "?")
        .replace(/["«»“”']/g, " ")
        .split(/\s+/)
        .filter((w) => w && !/^(ооо|оао|зао|пао|ао|ип|нпо|гк|тд)$/i.test(w));

    if (words.length === 0) {
        return "?";
    }

    return words
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase();
};

export const Avatar = memo(({ name, small }: { name: string; small?: boolean }) => (
    <span
        className={`${styles.avatar} ${small ? styles.avatarSmall : ""}`}
        style={{ background: colorOf(name || "?") }}
        title={name}
    >
        {initialsOf(name)}
    </span>
));
